module.exports = __webpack_public_path__ + "img/back4.6be6af20.gif";